module.exports = __webpack_public_path__ + "static/media/imbassaiBA.7787bfe0.jpg";